export const OPTION_VALUE_KEY = 'code';

export const OPTION_LABEL_KEY = 'translation';
